
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/projects/[projectSlug]",
      function () {
        return require("private-next-pages/projects/[projectSlug].tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/projects/[projectSlug]"])
      });
    }
  